import "./StagesCard.scss";

const StagesCard = ({ title, list, number }) => {
  return (
    <div className="stages-card">
      <div className="stages-card__wrapper">
        <div className="stages-card__content">
          <span className="stages-card__title">{title}</span>

          <ul className="stages-card__list">
            {list.map((desc, index) => (
              <li className="stages-card__item" key={index}>{desc}</li>
            ))}
          </ul>

        </div>
        <div className="stages-card__box">
          <span className="stages-card__number">{number}</span>
        </div>
      </div>
    </div>
  );
};


export default StagesCard